const link = "_link_ue21z_17";
const styles = {
  link
};
export {
  styles as default,
  link
};
//# sourceMappingURL=Link.module.css.js.map
